<template>
  <RouterLink :to="link.to" active-class="activeLink" class="px-3 py-2 text-decoration-none w-full hover:rounded hover:bg-gray-100 text-left relative flex">
    <p :class="[`${link.class} text-wcDarkGray text-xs`, {activeText: isActive()}]">{{ link.name }}</p>
  </RouterLink>
</template>

<script lang="ts">
interface LinkInterface {
  name?: string
  to?: string
  active?: string
  class?: string
  inputClass?: string
}
export default {
  name: 'LinkButton',
  props: {
    link: {
      type: Object as () => LinkInterface,
      required: true
    }
  },
  methods: {
    isActive() {
      const path = (this as any).$route.path
      return path.includes((this as any).link.active)
    }
  }

}
</script>
<style>
i {
  margin: 0;
}

</style>
<style>
 .activeLink {
   border-radius: 0.25rem;
   background-color: #eae9f8 !important;
   font-weight: 500;
 }
 .activeLink > p {
   color: #5138EE !important;
 }
 .activeText {
    width: 100%;
    color: #5138EE !important;
    height: 100% !important;
    font-weight: 500;
 }
</style>
